import { useSessionContext } from '@/contexts/session/context';
import CameraIcon from '@/assets/images/common/svg/camera.svg?react';
import { UploadAvatarCrop } from '@/components/upload-avatar';
import { userApis } from '@/configs/apis/user';
import { useChatContext } from '@/contexts/chat/context';
import useEditProfileFormModal from '../components/editProfileFormModal/useEditProfileFormModal';
import BackIcon from './images/back.svg?react';
import EditIcon from './images/edit.svg?react';
import EmjioIcon from './images/emjio.svg?react';
import MediaIcon from './images/media.svg?react';
import styles from './index.module.scss';
import bgImg from './images/bg.png';

const EditInfo = () => {
  const { showProfileInfo, setShowProfileInfo, updateUser } = useSessionContext();
  const { showEdit, info } = showProfileInfo;
  const { updateChats } = useChatContext();
  // const {
  //   formModalContext,
  //   setShow,
  //   form: usernameForm,
  // } = useEditProfileFormModal({
  //   title: 'Edit Username',
  //   formItems: [
  //     {
  //       formItem: {
  //         name: 'username',
  //         rules: [{ required: true, message: 'Please enter your username' }],
  //         extra:
  //           'Username: 6-15 characters (letters, numbers, _, or symbols only) UsernameID: One-time change allowed (unique ID)',
  //       },
  //       item: <Input placeholder="Enter your Username" showCount maxLength={15} />,
  //     },
  //   ],
  //   onFinish: async (values) => {
  //     const res = await userApis.usernameCheck({ username: values.username });
  //     if (res.code === 1) {
  //       await userApis.usernameUpdate({ username: values.username });
  //       await updateUser();
  //       setShow(false);
  //     }
  //   },
  //   onCancel: () => {
  //     usernameForm.resetFields();
  //   },
  //   onFinishText: 'Save',
  //   onCancelText: 'Cancel',
  // });
  const {
    formModalContext: nikeFormModalContext,
    setShow: setNikeShow,
    form: nikeForm,
  } = useEditProfileFormModal({
    title: 'Edit Nickname',
    formItems: [
      {
        formItem: {
          name: 'nickname',
          rules: [
            { required: true, whitespace: true, message: 'Please enter your nickname' },
          ],
        },
        item: <Input placeholder="Enter your nickname" showCount maxLength={15} />,
      },
    ],
    onFinish: async (values) => {
      await userApis.userInfoUpdate({ name: values.nickname });
      await updateUser();
      updateChats([{ chat_id: `P_${info.userId}`, name: values.nickname }]);
      setShowProfileInfo({ info: { ...info, name: values.nickname } });
      setNikeShow(false);
    },
    onCancel: () => {
      setNikeShow(false);
    },
    onFinishText: 'Save',
    onCancelText: 'Cancel',
  });
  return (
    <Modal
      width={472}
      className={styles.editInfoModal}
      title={
        <div
          className={styles.title}
          onClick={() => setShowProfileInfo({ showEdit: false, show: true })}
        >
          <BackIcon /> Edit Profile
        </div>
      }
      footer={null}
      open={showEdit}
      maskClosable={false}
      onCancel={() => {
        setShowProfileInfo({ showEdit: false });
      }}
    >
      <div className={cls(styles.main, 'scrollbar_hover')}>
        <div className={styles.infoWrap} style={{ backgroundImage: `url(${bgImg})` }}>
          <div className={styles.avatarWrap}>
            <UploadAvatarCrop
              uploadProps={{
                className: styles.uploadAvatar,
                onChange: (value) => {
                  if (value) {
                    userApis
                      .userInfoUpdate({ avatar: value })
                      .then(() => {
                        updateUser();
                        updateChats([{ chat_id: `P_${info.userId}`, avatar: value }]);
                        setShowProfileInfo({ info: { ...info, avatar: value } });
                      })
                      .catch(() => {});
                  }
                },
                children() {
                  return (
                    <>
                      <img className={styles.avatar} src={info.avatar!} />
                      <div className={styles.camera}>
                        <CameraIcon />
                      </div>
                    </>
                  );
                },
              }}
            ></UploadAvatarCrop>
          </div>
          <div className={styles.info}>
            <div className={styles.name}>{info.name}</div>
            <div
              className={styles.edit}
              onClick={() => {
                nikeForm.setFieldsValue({ nickname: info.name });
                setNikeShow(true);
              }}
            >
              <EditIcon />
            </div>
          </div>
          <div className={styles.icons}>
            <div className={styles.item}>
              <EmjioIcon />
              Profile icon
            </div>
            <div className={styles.item}>
              <MediaIcon />
              Animated Icon
            </div>
          </div>
        </div>
      </div>

      {/* {formModalContext} */}
      {nikeFormModalContext}
    </Modal>
  );
};

export default EditInfo;
